import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  routes,
  routesWithSidebar,
  publicRoutes,
  partnerRoutes
} from "./Routes";
import ProtectedRoute from "./ProtectedRoute";
import SidebarLayout from "../components/layouts/SidebarLayout";
import NotFound from "../pages/NotFound";
// import Login from "../pages/login";
import useAccountingSoftwareApi from "../hooks/useAccountingSoftwareApi";
import { FULFILLED } from "../utils/constants/appConstants";
import { useLocation } from "react-router-dom";
import PublicLayout from "../components/layouts/PublicLayout";
import { INVOICE } from "./paths";
import LoginWithRecaptcha from "../pages/login/LoginWithRecaptcha";

export const CustomRoute = () => {
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  const [navigateTo, setNavigateTo] = useState(null);
  const { GetConnectedSoftware, FundedDataCheck, ToFundDataCheck } =
    useAccountingSoftwareApi();
  const location = useLocation();
  useEffect(() => {
    const fetchData = async () => {
      const [connectedResult, fundedResult, toFundResult] =
        await Promise.allSettled([
          GetConnectedSoftware(),
          FundedDataCheck(),
          ToFundDataCheck()
        ]);

      const isConnected =
        connectedResult.status === FULFILLED
          ? (connectedResult.value?.data?.data?.isConnected ?? false)
          : false;

      const isFundedDataFound =
        fundedResult.status === FULFILLED &&
        Array.isArray(fundedResult.value?.data?.data) &&
        fundedResult.value.data.data.length > 0;

      const isToFundDataFound =
        toFundResult.status === FULFILLED &&
        Array.isArray(toFundResult.value?.data?.data) &&
        toFundResult.value.data.data.length > 0;

      if (isConnected || isFundedDataFound || isToFundDataFound) {
        setNavigateTo(INVOICE);
      } else {
        setNavigateTo(INVOICE);
      }
    };
    if (isAuthenticated === "true") {
      fetchData();
    }
  }, [isAuthenticated]);

  const renderLoginRoute = () => {
    if (isAuthenticated !== "true") return <LoginWithRecaptcha />;
    if (location.pathname === "/login" && navigateTo) {
      return <Navigate to={navigateTo} replace />;
    }
    return <Navigate to="/" replace />;
  };

  return (
    <Routes>
      {/* Applyed styled component */}
      <Route element={<PublicLayout />}>
        {/* Redirect if logged in */}
        <Route path="/login" element={renderLoginRoute()} />

        {/* Public routes */}
        {publicRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            caseSensitive={false}
            element={route.element}
          />
        ))}
      </Route>

      {/* Protected routes group */}
      <Route element={<ProtectedRoute />}>
        {/* Routes with sidebar layout */}
        <Route element={<SidebarLayout />}>
          {routesWithSidebar.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              caseSensitive={false}
              element={route.element}
            />
          ))}
        </Route>

        {/* Applyed styled component */}
        <Route element={<PublicLayout />}>
          {/* Other protected routes */}
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              caseSensitive={false}
              element={route.element}
            />
          ))}
        </Route>

        {/* Partner portal routes — layout is self-contained in each page */}
        {partnerRoutes.map((route, index) => (
          <Route
            key={`partner-${index}`}
            path={route.path}
            caseSensitive={false}
            element={route.element}
          />
        ))}
      </Route>

      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};
